import React from 'react';
import clsx from 'clsx';

export default class DataTableDisplayLengthToggle extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log('DisplayLengthToggle', this.props);

		if (!this.props.totalRecords) return null;

		let buttons = this.props.displayOptions.map((option) => {
			var classes = clsx('btn', this.props.pageLength === option && 'active');
			return (
				<button
					key={option}
					type="button"
					className={classes}
					onClick={this.props.onChangePageLength.bind(null, option)}
				>
					{option}
				</button>
			);
		});

		return (
			<div className="DataTableDisplayLengthToggle">
				<span className="display">{I18n.t('admin.display')}</span>
				{buttons}
			</div>
		);
	}
}
